import { $get } from '../axios';
import { encryptPwd } from '@/utils/crypto';

/** 设置二级密码 act=set_sec_pw */
export const setSecPw = ({ uin, password, vercode }) => {
  return $get('/creator/', {
    act: 'set_sec_pw',
    uin,
    pw: encryptPwd(password),
    vercode,
  });
};

/** 设置短信验证 act=set_phone_auth，flag：0 关闭 / 1 开启 */
export const setPhoneAuth = ({ uin, vercode, flag }) => {
  return $get('/creator/', {
    act: 'set_phone_auth',
    uin,
    vercode,
    flag,
  });
};

/** 关闭二级密码 act=close_sec_pw */
export const closeSecPw = ({ uin, vercode }) => {
  return $get('/creator/', {
    act: 'close_sec_pw',
    uin,
    vercode,
  });
};

/** 校验二级密码 act=auth_sec_pw */
export const authSecPw = ({ uin, password }) => {
  return $get('/creator/', {
    act: 'auth_sec_pw',
    uin,
    pw: encryptPwd(password),
  });
};
